if (import.meta.env.DEV) {
  import("react-grab");
}

import { createRoot } from "react-dom/client";

import * as chmln from "@chamaeleonidae/chmln";
import { App } from "@src/App";
import { initMixpanel } from "@src/bootstrap/initMixpanel";
import { COMMON_IGNORE_ERRORS, initSentry } from "@src/bootstrap/initSentry";
import { MixpanelConfig } from "@src/bootstrap/MixpanelConfig";
import { registerVitePreloadRecovery } from "@src/bootstrap/registerVitePreloadRecovery";
import { setupAgGrid } from "@src/bootstrap/setupAgGrid";

import { message } from "./utils/message";
import { widgetAuth } from "./utils/widgetAuth";

// Initialize AG-Grid
const isProd = window.location.hostname === "app.intelligems.io";
setupAgGrid({
  licenseKey:
    "Using_this_{AG_Grid}_Enterprise_key_{AG-076655}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Intelligems}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{intelligems.io}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{intelligems.io}_need_to_be_licensed___{intelligems.io}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{6_February_2026}____[v3]_[01]_MTc3MDMzNjAwMDAwMA==4a993a3369ba60e3c8f6ee1924f099f7",
  includeValidation: !isProd,
});

export const REACT_QUERY_CACHE = "REACT_QUERY_OFFLINE_CACHE";

// Initialize Mixpanel
initMixpanel(MixpanelConfig);

const extendedIgnoreErrors = [
  ...COMMON_IGNORE_ERRORS,
  "Cannot read properties of undefined (reading 'content')",
  "Failed to get Hubspot Token",
  "Cannot read properties of null (reading 'style')",
  `The pseudo class ":nth-child" is potentially unsafe`,
  "signal is aborted without reason",
  "Failed to fetch (sevendata.fun)",
  "Failed to fetch (polyfilljs.org)",
  "Request failed with status code 401",
  `can't access property "join", i.messages is undefined`,
];

// Initialize Sentry
initSentry({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  environment: import.meta.env.VITE_STAGE,
  enabled:
    !import.meta.env.DEV && import.meta.env.VITE_RUNNING_LOCAL !== "true",
  tracesSampleRate: 0.05,
  ignoreErrors: extendedIgnoreErrors,
});

chmln.init(
  "SxlAgsazrkfpVoGLnGoPgckkd8lwl6fW3fkHdtpP87buvK-1TIXQ8-FJs4pClLJBcELMEL",
  { fastUrl: "https://fast.chameleon.io/" }
);

registerVitePreloadRecovery();

function main() {
  const isNotIframe = Boolean(
    window.parent === window ||
    window["IS_MARKUP_TOP_FRAME"] ||
    window.parent["MARKUP_EXTENSION_ID"]
  );

  if (isNotIframe) {
    const rootApp = <App />;

    const container = document.getElementById("root");

    if (!container) throw new Error("Could not find container #root");

    window.addEventListener(
      "beforeunload",
      () => {
        console.log("beforeunload");
        message({ type: "CLOSED" }, "*");
      },
      { capture: true }
    );

    const root = createRoot(container);
    root.render(rootApp);
  } else {
    // inside an iframe
    widgetAuth();
  }
}

main();
